import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../../api/gen/api/customer.service';
import { CustomerDto } from '../../../api/gen/model/customerDto';
import { OperatorGroupDto } from '../../../api/gen/model/operatorGroupDto';
import { JjamesButtonComponent, JJamesCardComponent, JJamesAlertComponent, ResponsiveBaseComponent } from 'shared-lib';

@Component({
    selector: 'app-customer-view',
    standalone: true,
    imports: [
        CommonModule,
        JjamesButtonComponent,
        JJamesCardComponent,
        JJamesAlertComponent
    ],
    templateUrl: './customer-view.component.html',
    styleUrls: ['./customer-view.component.scss']
})
export class CustomerViewComponent extends ResponsiveBaseComponent implements OnInit {
    private readonly customerService = inject(CustomerService);
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);

    customer = signal<CustomerDto | null>(null);
    loading = signal(false);
    errorMessage = signal<string | null>(null);
    customerId: string | null = null;

    ngOnInit(): void {
        this.customerId = this.route.snapshot.paramMap.get('customerId');
        if (this.customerId) {
            this.loadCustomer();
        } else {
            this.errorMessage.set('No customer ID provided');
        }
    }

    loadCustomer(): void {
        if (!this.customerId) return;

        this.loading.set(true);
        this.errorMessage.set(null);

        this.customerService.customerCustomerIdGet(this.customerId, true, false).subscribe({
            next: (response) => {
                if (response) {
                    this.customer.set(response);
                }
                this.loading.set(false);
            },
            error: (error) => {
                console.error('Error loading customer:', error);
                this.errorMessage.set('An error occurred while loading customer details');
                this.loading.set(false);
            }
        });
    }

    goBack(): void {
        this.router.navigate(['/customer-management']);
    }

    editCustomer(): void {
        if (this.customerId) {
            this.router.navigate(['/customer-management', this.customerId, 'edit']);
        }
    }

    createOperator(): void {
        this.router.navigate(['/user-management/operator-management/create'], {
            queryParams: { customerId: this.customerId }
        });
    }

    viewGroupMembers(groupId?: string): void {
        if (this.customerId && groupId) {
            this.router.navigate(['/customer-management', this.customerId, 'group', groupId, 'members']);
        }
    }

    getGroupRoleBadgeClass(role?: string): string {
        switch (role) {
            case 'Admin':
                return 'bg-red-100 text-red-800';
            case 'SuperUser':
                return 'bg-purple-100 text-purple-800';
            case 'Owner':
                return 'bg-yellow-100 text-yellow-800';
            case 'Member':
                return 'bg-blue-100 text-blue-800';
            case 'Viewer':
                return 'bg-gray-100 text-gray-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    }
}
